import R from 'ramda'
import moment from 'moment'

const compareBookingTime = (prop, comperator) => (timestamp) => R.pipe(
  R.path(['duration', prop]),
  moment.utc,
  Number,
  comperator(+moment.utc(timestamp))
)

export const isGtStart = compareBookingTime('start', R.gt)
export const isLtEnd = compareBookingTime('end', R.lt)
export const isLtStart = compareBookingTime('start', R.lt)
